__turbopack_context__.v({
  "background": "P4pL_a_background",
  "wrapper": "P4pL_a_wrapper",
});
